// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/asset/v1/asset.proto (package fingertip.creator.asset.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Asset, CreateAssetItem } from "../../../common/type/v1/asset_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";

/**
 * @generated from message fingertip.creator.asset.v1.CreateAssetRequest
 */
export const CreateAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.CreateAssetRequest",
  () => [
    { no: 1, name: "assets", kind: "message", T: CreateAssetItem, repeated: true },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.CreateAssetResponse
 */
export const CreateAssetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.CreateAssetResponse",
  () => [
    { no: 1, name: "asset_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.GetAssetRequest
 */
export const GetAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.GetAssetRequest",
  () => [
    { no: 1, name: "asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.GetAssetResponse
 */
export const GetAssetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.GetAssetResponse",
  () => [
    { no: 1, name: "asset", kind: "message", T: Asset },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.CreatePublicAssetRequest
 */
export const CreatePublicAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.CreatePublicAssetRequest",
  () => [
    { no: 1, name: "assets", kind: "message", T: CreateAssetItem, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.CreatePublicAssetResponse
 */
export const CreatePublicAssetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.CreatePublicAssetResponse",
  () => [
    { no: 1, name: "asset_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.DeleteAssetRequest
 */
export const DeleteAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.DeleteAssetRequest",
  () => [
    { no: 1, name: "asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.DeleteAssetResponse
 */
export const DeleteAssetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.DeleteAssetResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.DeletePublicAssetRequest
 */
export const DeletePublicAssetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.DeletePublicAssetRequest",
  () => [
    { no: 1, name: "asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.DeletePublicAssetResponse
 */
export const DeletePublicAssetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.DeletePublicAssetResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.GetSiteAssetsRequest
 */
export const GetSiteAssetsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.GetSiteAssetsRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.asset.v1.GetSiteAssetsResponse
 */
export const GetSiteAssetsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.asset.v1.GetSiteAssetsResponse",
  () => [
    { no: 1, name: "assets", kind: "message", T: Asset, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

